// ═══════════════════════════════════════════════════════════════════════════════
// Employer Level Limits Schemas (§22)
// ═══════════════════════════════════════════════════════════════════════════════
import { z } from 'zod';
import { TASK_KIND } from '../constants/index.js';
import { USER_LEVEL } from '../types/employerLimits.js';
const taskKindSchema = z.enum([
    TASK_KIND.STANDARD,
    TASK_KIND.INVENTORY,
    TASK_KIND.PICKUP_DROPOFF,
    TASK_KIND.MEDICATION_REMINDER,
]);
const employerLevelLimitsConfigSchema = z.object({
    maxTotalTasks: z.number().int().min(0).nullable(),
    maxDailyTaskSubmits: z.number().int().min(0),
    maxDailyTaskReviews: z.number().int().min(0),
    maxDailyReceipts: z.number().int().min(0),
    maxDailyAiAnalyze: z.number().int().min(0),
    maxCommentsPerTarget: z.number().int().min(0),
    maxCommentLength: z.number().int().min(1),
    autoTranslationEnabled: z.boolean(),
    allowedTaskKinds: z.array(taskKindSchema).min(1),
    maxInventoryLocations: z.number().int().min(0).nullable(),
    maxInventoryCategories: z.number().int().min(0).nullable(),
});
export const limitsByLevelSettingSchema = z.object({
    levels: z.record(z.string(), employerLevelLimitsConfigSchema.partial()),
});
export const userLevelSchema = z.union([
    z.literal(USER_LEVEL.TRIAL),
    z.literal(USER_LEVEL.FREE),
    z.literal(USER_LEVEL.PAID),
]);
//# sourceMappingURL=employerLimits.schema.js.map